export const onFocusChangeFocusTo = (querySelector, element = null) => {
  const target = element ? element.querySelector(querySelector) : document.querySelector(querySelector);
  if (target) target.focus();
};

//use on tabindex, will return -1 (untabable) or null (default behaviour)
export const unTabable = (condition) => {
  return condition ? -1 : null;
};

//use on tabindex, will return 0 (tabable) or null (default behaviour)
export const tabable = (condition) => {
  return condition ? 0 : null;
};
